module.exports = __webpack_public_path__ + "static/media/unbound9.d9db7a1c.png";